import React from 'react';
import { useSelector } from 'react-redux';
import { Logger } from 'aws-amplify';
import { NotificationBadge } from 'src/legacy/components/UI/Badges';
import { RootState } from 'src/store';
import { isUnreadNotification } from 'src/utils/NotificationsUtils';
import { EsigRequestNotification } from 'src/store/notifications/types';
import { FlagsContext } from '../../../../context';

const logger = new Logger('ContractNotificationsBadge');

// FormsNotificationsBadge notifications for forms events
export const ContractNotificationsBadge = () => {
  const { EnableManyCompanies } = React.useContext(FlagsContext);
  const isClient = useSelector((state: RootState) => state.user.isClient);
  const activeCompanyId = useSelector(
    (state: RootState) => state.activeCompany.activeCompanyId,
  );
  let notifications: EsigRequestNotification[] = [];
  // Get the notifications from the store according to the user role
  if (isClient) {
    notifications =
      useSelector(
        (state: RootState) => state.notifications.esigRequestNotifications,
      ) || [];

    const filteredNotifications = React.useMemo(() => {
      if (EnableManyCompanies) {
        return notifications.filter(
          (notif) => notif.companyId === activeCompanyId,
        );
      }
      return notifications;
    }, [EnableManyCompanies, notifications, activeCompanyId]);

    notifications = filteredNotifications;
  }

  const [notificationsCounter, setNotificationsCounter] = React.useState(0);

  React.useEffect(() => {
    logger.debug('Setting primary forms sidebar notification');
    // filter unread notification
    logger.debug('Total notifications:', notifications.length);
    const unreadNotifications = notifications.filter((notif) =>
      isUnreadNotification(notif),
    );

    logger.debug('Unread notifications:', unreadNotifications.length);

    setNotificationsCounter(unreadNotifications.length);
  }, [notifications]);

  return (
    <NotificationBadge
      showZero={false}
      isSidebar
      content={notificationsCounter}
    />
  );
};
